<template>
	<div id="app">
		<el-container>
			<el-header>
				<div class="header">
					<div class="logo">
						<img src="./assets/img/logo_top.png" alt />
					</div>
					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
						:router="router">
						<el-menu-item class="app-menu" index="/">首页</el-menu-item>
						<el-menu-item class="app-menu" index="/introduction">术仁风采</el-menu-item>
						<!-- type 1 √ -->
						<el-submenu index="guide" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetGuide')">就医指南</div>
							</template>
							<el-menu-item ref="targetGuide" index="/guide/1">就诊须知</el-menu-item>
							<el-menu-item index="/guide/2">挂号须知</el-menu-item>
							<el-menu-item index="/guide/3">健康体检</el-menu-item>
							<el-menu-item index="/guide/4">智慧医院</el-menu-item>
							<el-menu-item index="/guide/5">医院位置</el-menu-item>
						</el-submenu>
						<!-- type 4 -->
						<el-submenu index="treatment" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetTreatment')">特色医疗</div>
							</template>
							<el-menu-item ref="targetTreatment" index="/treatment/1">术仁名老中医</el-menu-item>
							<el-menu-item index="/treatment/2">中医特色疗法</el-menu-item>
							<el-menu-item index="/treatment/3">中医特色护理</el-menu-item>
							<el-menu-item index="/treatment/4">中药炮制展示</el-menu-item>
							<el-menu-item index="/treatment/5">中医体质辨识</el-menu-item>
						</el-submenu>

						<!-- type 3 -->
						<!-- <el-menu-item class="app-menu" index="/department">科室导航</el-menu-item> -->
						<el-submenu index="/department" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetDepartment')">科室导航
								</div>
							</template>
							<el-menu-item index="/department/1" ref="targetDepartment">科室介绍</el-menu-item>
							<el-menu-item index="/department/2">医生介绍</el-menu-item>
						</el-submenu>
						<!-- type 2 √ -->
						<el-submenu index="news" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetNews')">医院资讯</div>
							</template>
							<el-menu-item index="/news/1" ref="targetNews">医疗动态</el-menu-item>
							<el-menu-item index="/news/2">行业新闻</el-menu-item>
							<el-menu-item index="/news/3">健康科普</el-menu-item>
							<el-menu-item index="/news/4">媒体报道</el-menu-item>
							<el-menu-item index="/news/5">患者之声</el-menu-item>
						</el-submenu>

						<!-- type 5 -->
						<el-submenu index="YangLao" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetYangLao')">居家养老</div>
							</template>
							<el-menu-item index="/yanglao/1" ref="targetYangLao">养老中心</el-menu-item>
							<el-menu-item index="/yanglao/2">优势特色</el-menu-item>
							<el-menu-item index="/yanglao/3">环境设施</el-menu-item>
							<el-menu-item index="/yanglao/4">护理团队</el-menu-item>
						</el-submenu>
						<!-- type 6 √ -->
						<el-submenu index="dangjian" :show-timeout="0" :hide-timeout="300">
							<template slot="title">
								<div class="el-submenu-template-div" @click="triggerClick('targetDangJian')">党建工作</div>
							</template>
							<el-menu-item ref="targetDangJian" index="/dangjian/1">党群建设</el-menu-item>
							<el-menu-item index="/dangjian/2">清廉医院</el-menu-item>
							<el-menu-item index="/dangjian/3">职工之家</el-menu-item>
						</el-submenu>

						<el-menu-item class="app-menu" index="/join">加入我们</el-menu-item>
						<el-menu-item class="app-manager" v-if="isManager()" index="/admin"><i class="el-icon-user"
								style=""></i></el-menu-item>
						<el-menu-item class="app-manager" v-else index="/admin"><i
								class="el-icon-user-solid"></i></el-menu-item>
					</el-menu>
				</div>

			</el-header>
			<el-main class="el-main-margin-top">
				<router-view />
			</el-main>

			<div class="liao-jie-geng-duo" v-show="moreShow">
				<div class="ljgd" style="">
					<img class="ljgd-img-1" src="./assets/img/liaojiegengduo.png" />
					<img class="ljgd-img-2" src="./assets/img/liaojiegengduo-erweima.png" />
					<div class="ljgd-2wm-1">
						<img src="./assets/二维码/了解更多-二维码-1.jpg" style="width: 100%;" />
						<p>微信公众号</p>
					</div>

					<div class="ljgd-2wm-2">
						<img src="./assets/二维码/了解更多-二维码-2.jpg" style="width: 100%;" />
						<p>美团二维码</p>
					</div>

				</div>
			</div>

			<div class="footer" v-show="isShow">
				<!-- <div class="footer-title">
					<span>本网站不提供任何收费服务，仅为信息分享。</span>
				</div> -->
				<div class="footer-content">
					<ul class="content-nav">
						<li>
							<p class="footer-btn" @click="goToPage('guide', 1)">就医指南</p>
							<span class="footer-btn" @click="goToPage('guide', 1)">就诊须知</span>
							<span class="footer-btn" @click="goToPage('guide', 2)">挂号须知</span>
							<span class="footer-btn" @click="goToPage('guide', 3)">健康体检</span>
							<span class="footer-btn" @click="goToPage('guide', 4)">智慧医院</span>
							<span class="footer-btn" @click="goToPage('guide', 5)">医院位置</span>
						</li>
						<li>
							<p class="footer-btn" @click="goToPage('treatment', 1)">特色医疗</p>
							<span class="footer-btn" @click="goToPage('treatment', 1)">术仁名老中医</span>
							<span class="footer-btn" @click="goToPage('treatment', 2)">中医特色疗法</span>
							<span class="footer-btn" @click="goToPage('treatment', 3)">中医特色护理</span>
							<span class="footer-btn" @click="goToPage('treatment', 4)">中药炮制展示</span>
							<span class="footer-btn" @click="goToPage('treatment', 5)">中医体质辨识</span>
						</li>
						<li>
							<p class="footer-btn" @click="goToPage('department', 1)">科室导航</p>
							<span class="footer-btn" @click="goToPage('department', 1)">科室介绍</span>
							<span class="footer-btn" @click="goToPage('department', 2)">医生介绍</span>
						</li>
						<li>
							<p class="footer-btn" @click="goToPage('news', 1)">医院资讯</p>
							<span class="footer-btn" @click="goToPage('news', 1)">医疗动态</span>
							<span class="footer-btn" @click="goToPage('news', 2)">行业新闻</span>
							<span class="footer-btn" @click="goToPage('news', 3)">健康科普</span>
							<span class="footer-btn" @click="goToPage('news', 4)">媒体报道</span>
							<span class="footer-btn" @click="goToPage('news', 5)">患者之声</span>
						</li>
						<li>
							<p class="footer-btn" @click="goToPage('yanglao', 1)">居家养老</p>
							<span class="footer-btn" @click="goToPage('yanglao', 1)">养老中心</span>
							<span class="footer-btn" @click="goToPage('yanglao', 2)">优势特色</span>
							<span class="footer-btn" @click="goToPage('yanglao', 3)">环境设施</span>
							<span class="footer-btn" @click="goToPage('yanglao', 4)">护理团队</span>
						</li>
						<li>
							<p class="footer-btn" @click="goToPage('dangjian', 1)">党建工作</p>
							<span class="footer-btn" @click="goToPage('dangjian', 1)">党群建设</span>
							<span class="footer-btn" @click="goToPage('dangjian', 2)">清廉医院</span>
							<span class="footer-btn" @click="goToPage('dangjian', 3)">职工之家</span>

						</li>
						<li>
							<p>联系我们</p>
							<span>线上挂号/问诊/健康/动态</span>
							<span>联系电话：0731-84916120</span>
							<!-- <span>邮箱地址：text@email.com</span> -->
							<span>医院地址：长沙市岳麓区莲花镇云盖村部/黄桥大道旁</span>
						</li>
					</ul>
					<div>
						<img src="./assets/二维码/底边栏-二维码.jpg" alt />
						<p>微信公众号</p>
					</div>
					
				</div>

				<div class="footer-author">
					<div>
						<img class="" style="width: 20px; height: 20px;" src="./assets/img/备案图标.png"/>
						<span class="url-style" 
							@click="goToUrl('https://beian.mps.gov.cn/#/query/webSearch?code=43010402002238')">
							湘公网安备43010402002238号
						</span>
					</div>
					<div>ICP备案号: <span class="url-style" @click="goToUrl('https://beian.miit.gov.cn')">湘ICP备2024058487号-2</span></div>
					<div>网站搭建: acerolan@foxmail.com</div>
				</div>

			</div>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				router: true,
				activeIndex: "/",
				isShow: false,
				moreShow: false,
			};
		},
		watch: {
			$route() {
				this.setCurrentRoute();
			},
		},
		created() {
			this.setCurrentRoute();
		},
		methods: {
			handleSelect() {
				return;
			},
			setCurrentRoute() {
				var path = this.$route.path;
				this.activeIndex = (path.startsWith('/admin') ? '/admin' : path);

				if (this.activeIndex != '/') {
					this.isShow = true;
				} else {
					this.isShow = false;
				}

				if (path == '/' || this.activeIndex == '/admin') {
					this.moreShow = false;
				} else {
					this.moreShow = true;
				}
				// window.console.log(this.isShow);
			},
			isManager() {
				return (sessionStorage.getItem("token") == null);
			},
			handleMenuClick(type) {
				// 跳转到指定路径
				this.$router.push({
					name: 'news',
					params: {
						type: type
					}
				});
			},
			triggerClick(target) {
				// 通过$el获取组件根DOM
				if (target === 'targetGuide') this.$refs.targetGuide.$el.click();
				else if (target === 'targetTreatment') this.$refs.targetTreatment.$el.click();
				else if (target === 'targetDepartment') this.$refs.targetDepartment.$el.click();
				else if (target === 'targetNews') this.$refs.targetNews.$el.click();
				else if (target === 'targetYangLao') this.$refs.targetYangLao.$el.click()
				else if (target === 'targetDangJian') this.$refs.targetDangJian.$el.click();
			},
			goToPage(addr, part) {
				if (this.$route.path !== '/'+addr+'/'+part) {
				    this.$router.push('/'+addr+'/'+part);
				}
				// 下列方法进入新addr时会报错，暂未找到解决方法
				// this.$router.push({
				// 	name: addr,
				// 	params: {
				// 		part: part
				// 	}
				// })
			},
			goToUrl(url) {
				window.open(url);
			}
		},
	};
</script>

<style lang="scss">
	* {
		padding: 0;
		margin: 0;
	}

	html,
	body {
		height: 100%;
	}

	// 子菜单展开宽度，匹配导航栏标题宽度
	.el-menu--popup {
		min-width: 96px !important;
		/* 设置你需要的宽度 */
		text-align: center;
	}

	/* 覆盖 el-submenu 的默认激活下划线 */
	.el-submenu.is-active .el-submenu__title {
		border-bottom: none !important;
		/* 移除默认蓝色下划线 */
	}

	/* 隐藏所有子菜单的箭头图标 */
	.el-submenu__title i.el-icon-arrow-down {
		display: none !important;
	}

	/* 添加自定义下划线 */
	.el-submenu.is-active .el-submenu__title {
		border-bottom: 3px solid #972326 !important;
		/* 替换成你的颜色 */
	}

	.el-submenu-template-div {
		line-height: 62px;
	}

	.app-menu.is-active {
		border-bottom: 3px solid #972326 !important;
	}

	.app-manager.is-active {
		color: #972326 !important;
		border-bottom: none !important;
	}

	#app {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	.el-header {
		display: flex;
		// justify-content: center;
		// align-content: center;
		width: 100%;
		min-width: 1240px;
		margin: 0 auto;
		position: fixed;
		left: 50%;
		top: 0;
		z-index: 1000;
		transform: translate(-50%);
		background-color: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		/* 可选：添加阴影效果 */

		.header {
			display: flex;
			justify-content: space-between;
			align-content: center;
			width: 1400px;
			margin: 0 auto;
			background-color: #fff;
			overflow: hidden;
		}

		.logo {
			width: 280px;
			padding: 5px;

			img {
				width: 100%;
				line-height: 60px;
			}
		}
	}

	.el-main-margin-top {
		margin-top: 60px;
		/* 根据导航栏实际高度调整 */
		padding: 0 !important;
	}

	.liao-jie-geng-duo {
		width: 250px;
		position: fixed;
		top: 50%;
		right: -200px;
		transition: all 0.3s ease;

		&:hover {
			transition: all 0.3s ease;
			right: 0;
		}

		.ljgd {
			position: relative;

			&-img-1 {
				width: 50px;
				// cursor: pointer;
				position: absolute;
				transform: translate(0, -50%);
			}

			&-img-2 {
				width: 200px;
				position: absolute;
				left: 50px;
				transform: translate(0, -50%);
			}

			&-2wm-1 {
				width: 160px;
				position: absolute;
				top: -215px;
				right: 20px;
				text-align: center;
			}

			&-2wm-2 {
				width: 160px;
				position: absolute;
				top: 15px;
				right: 20px;
				text-align: center;
			}

		}
	}

	.footer {
		width: 100%;
		// height: 250px;
		overflow: hidden;
		background-color: #972326;

		&-title {
			padding-top: 10px;
			display: flex;
			justify-content: space-around;
			color: white;
			font-weight: bold;
			font-size: 24px;
			text-align: center;
		}

		&-author {
			display: flex;
			justify-content: space-evenly;
			height: 60px;
			line-height: 60px;
			color: white;
		}

		&-content {
			width: 1360px;
			margin: 0 auto;
			padding-top: 10px;
			display: flex;
			justify-content: space-between;

			.content-nav {
				display: flex;
				justify-content: space-around;

				li {
					display: flex;
					flex-direction: column;
					padding: 0 15px;
					//justify-content: center;
					align-items: flex-start;

					p {
						font-size: 20px;
						color: #d4edff;
						padding: 10px 0;
					}

					span {
						color: #f7f7f7;
						font-weight: 300;
						padding: 5px 0;
					}
				}
			}

			img {
				width: 160px;
				height: 160px;
				padding: 10px 20px;
			}
			
			p {
				color: #f7f7f7;
				font-weight: 300;
				text-align: center;
			}
		}

		/* 底部导航栏文字按钮样式 */
		.footer-btn {
			transition: all 0.3s;

			&:hover {
				cursor: pointer;
				transform: scale(1.05);
				transition: all 0.3s ease;
			}
		}
		.url-style {
			cursor: pointer;
		
			&:hover {
				color: #d4edff;
			}
		}
	}

	/* 调整所有消息提示的位置 */
	.el-message {
		top: 60px !important;
		/* 下移60px，避开导航栏 */
		z-index: 9999 !important;
		/* 确保在最上层 */
	}
</style>